import React from "react";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

const CompanyRow = props => {
  const { company } = props;
  const navigate = useNavigate();
  return (
    <div className={"fulfilment-company"}>
      <div className={"fulfilment-company-details"}>
        <div style={{ display: "flex" }}>
          <div className="fulfilment-company-date">
            {moment(company.fulfilmentDeadline).format("D MMMM YYYY")}
          </div>
          <div className="fulfilment-company-name">{company.customerName}</div>
        </div>
        <div
          className={"fulfilment-company-arrow"}
          onClick={() =>
            navigate(`/fulfilments/activities/${company.fulfilmentId}?customer=${company.customerId}`)
          }
        >
          <FontAwesomeIcon icon={["fas", "arrow-right"]} />
        </div>
      </div>
      <div className={"fulfilment-company-progress"}>
        <ProgressBar
          percentage={Math.round((company.fulfilmentCompletedActivities /
              company.fulfilmentActivities) *
              100)}
          progressBarLabel={" "}
          completedElements={company.fulfilmentCompletedActivities}
          totalElements={company.fulfilmentActivities}
        />
      </div>
    </div>
  );
};

export default CompanyRow;
